/**
 * External Imports
 */
import styled from 'styled-components';

export const SupportContainer = styled.main`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 128px);
`;

export const TaskContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 128px);
`;

export const ProfileContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 68px);
`;
